import {reqWithToken} from './requestHelper';

//crud

export async function insert(insert) {
    return (await reqWithToken('api/english',{
        method: 'post',
        data: insert
    })).data;
}

export async function getstud() {

    return (await reqWithToken('api/english/studentdata')).data;
}

export async function get(id) {
    return (await reqWithToken(`api/english/${id}`,)).data;
}



export async function getAll() {
    return (await reqWithToken('api/english')).data;
}

export async function getstudentAll() {
    return (await reqWithToken('api/english/getstudentAll')).data;
}

export async function update(update) {
    return (await reqWithToken('api/english',{
        method: 'put',
        data: update
    })).data;
}

export async function remove(id) {
    return (await reqWithToken('api/english/',{
        method: 'delete',
        params: {id}
    })).data;
}

export async function getFormActionByInfo(update) {
    return (await reqWithToken('api/english/getFormActionByInfo',{
        method: 'put',
        data: update
    })).data;
}

